import {useState, useEffect } from 'react';

const useHoverImg = (imgRef, defaultImg, hoverImg) =>{
    const [currentImg, setCurrentImg] = useState(defaultImg);

    useEffect(()=>{
        //initialize the image bucket to use
        const imgElement = imgRef.current;

        if(!imgElement){
            return;
        };

        const handleMouseEnter =()=>{
            setCurrentImg(hoverImg);
        };

        const handleMouseLeave =() =>{
            setCurrentImg(defaultImg);
        }

        //event lsiterner
        imgElement.addEventListener('mouseenter', handleMouseEnter);
        imgElement.addEventListener('mouseleave', handleMouseLeave);

        //clean up after eveyrhting unmounts so no memory leak or anything else goes horribly wrong
        return()=>{
            imgElement.removeEventListener('mouseenter', handleMouseEnter);
            imgElement.removeEventListener('mouseleave',handleMouseLeave);
        };

    },[imgRef,defaultImg, hoverImg]);//these are what's changing so depencency array has this
    return currentImg;
}

export default useHoverImg;